module.exports = __webpack_public_path__ + "static/media/ic_pay_mastercard.dad924a7.svg";